/* eslint-disable no-new */

import Analytics from 'root/apps/shared_modules/Analytics';
import HelpModal from 'root/apps/help_modal/HelpModal';
import ItemImportHelp from 'root/apps/item_import/ItemImportHelp';
import VoidSale from 'root/apps/void_sale_modal/VoidSale';
import PublishToEcom from 'root/apps/publish_to_ecom/PublishToEcom';
import Intercom from 'root/apps/intercom/Intercom';
import Appcues from 'root/apps/appcues/Appcues';
import Qualtrics from 'root/apps/qualtrics/Qualtrics';
import { initHub } from 'pages/views/devices/utils/client';
import { getEnvFromHostname, ENVIRONMENTS } from 'pages/utils/getEnvFromHostname';
import 'root/apps/Hub/Receipt';
import 'root/apps/helpers/react-component-history';
import 'root/apps/item_import/import_type_select/ImportTypeSelect';
import 'root/apps/matrix/MatrixAttributes';
import 'root/apps/getting_started/GettingStarted';
import 'root/apps/publish_to_ecom/PublishToEcomButtons';
import 'root/apps/brands/BrandsAutocomplete';
import 'root/apps/item_chart/ItemChart';
import 'root/apps/RegisterRules';
import 'root/apps/item_inventory/Transfer';
import 'root/apps/address/Address';
import 'root/lib/embeds/localize';
import 'root/calendar/CalendarLocale';
import 'root/apps/importSass';
import 'root/system';
import 'root/apps/pikaday/pikaday';
import 'root/apps/MakeTaxDigitalUK';
import 'root/merchantos/server_call';
import 'root/merchantos/register';
import 'root/merchantos/register/terminal_payment';
import 'root/merchantos/product_images/product_image';
import 'pages/components/RichTextEditor';
import 'pages/gui-defs/VendorsAutocomplete';
import 'pages/gui-defs/EcomRadManagement';
import 'pages/gui-defs/DeleteAccount';
import 'pages/gui-defs/CustomAlert';
import 'pages/gui-defs/ConsentConfirmation';
import 'pages/index';
import 'pages/gui-defs/CreateVendorReturn';
import 'pages/gui-defs/EmployeeShops';
import 'pages/components/Sidebar';
import 'pages/gui-defs/DiscountRules';
import 'payments/PaymentsPanel';

$(async () => {
  await import('root/apps/components/Topbar');

  Analytics.init();

  if (getEnvFromHostname() !== ENVIRONMENTS.DEVELOPMENT) {
    Appcues.init();
  }

  initHub();

  if (window.lsCloud.Modules.hasModule('intercom.support')) {
    Intercom.init();
  }

  Qualtrics.init();

  new HelpModal();
  new ItemImportHelp();
  new VoidSale();
  new PublishToEcom();

  // Trigger a changeState event to mount components on the register.
  if (!window.history_changed && window.location.pathname === '/register.php') {
    window.history.changeState();
  }
});
